import type { IconName } from '@/ui/icons';
/**
 * Which tabs Fravær offers and which one is showing (C10, 2026-09-21).
 *
 * Two rules worth keeping honest: Saldo is not a tab for somebody who may not see the
 * balances, and an address naming a tab that is not on offer opens the queue rather than
 * nothing. The second matters because a bookmark outlives a permission.
 */
export type TabKey = 'soknader' | 'kalender' | 'saldo' | 'ferieliste' | 'statistikk';

/** Each tab's icon beside its label (#154 BR-10, BR-12); the label stays the name */
export const TAB_ICON: Record<TabKey, IconName> = {
  soknader: 'inbox',
  kalender: 'calendar',
  saldo: 'clock',
  ferieliste: 'list',
  statistikk: 'chart',
};

export const tabsFor = (maySeeBalances: boolean): [TabKey, string][] => [
  ['soknader', 'Søknader'],
  ['kalender', 'Kalender'],
  ...(maySeeBalances ? ([['saldo', 'Saldo']] as [TabKey, string][]) : []),
  // #114: who has holiday when, for everyone who may see absence; it carries no balance
  ['ferieliste', 'Ferieliste'],
  ['statistikk', 'Statistikk'],
];

export const tabFrom = (path: string | undefined, maySeeBalances: boolean): TabKey =>
  tabsFor(maySeeBalances).some(([k]) => k === path) ? (path as TabKey) : 'soknader';
